import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";
import ContractImportMedia from "./ContractImportMedia";

export default class Contract extends Model {
    static entity = 'contract_imports';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'id',
    };

    static fields() {
        return {
            id: this.uid(),
            file_name: this.string(null),
            contract_id: this.string(null).nullable(),
            contract_date: this.string(null).nullable(),
            creator: this.string(null).nullable(),
            alias: this.string(null).nullable(),
            company: this.string(null).nullable(),
            has_duplicate_media_items: this.boolean(false),
            duplicate_media_items: this.attr([]).nullable(),

            created_at: this.string(''),
            updated_at: this.string(''),

            contractImportMedia: this.hasMany(Contract, 'contract_import_id'),
        }
    }

    declare id: number;
    declare file_name: string | null;
    declare contract_id: string | null;
    declare contract_date: string | null;
    declare creator: string | null;
    declare alias: string | null;
    declare company: string | null;
    declare has_duplicate_media_items: boolean;
    declare duplicate_media_items: Array<ContractImportMedia> | null;
}
